import { render, staticRenderFns } from "./MiscBacklog.vue?vue&type=template&id=3a1e7636&"
import script from "./MiscBacklog.vue?vue&type=script&lang=js&"
export * from "./MiscBacklog.vue?vue&type=script&lang=js&"
import style0 from "./MiscBacklog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports